import { render, staticRenderFns } from "./DeptStaffIndex.vue?vue&type=template&id=7fc5f7fa"
import script from "./DeptStaffIndex.vue?vue&type=script&lang=js"
export * from "./DeptStaffIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7fc5f7fa')) {
      api.createRecord('7fc5f7fa', component.options)
    } else {
      api.reload('7fc5f7fa', component.options)
    }
    module.hot.accept("./DeptStaffIndex.vue?vue&type=template&id=7fc5f7fa", function () {
      api.rerender('7fc5f7fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/auth/staff/DeptStaffIndex.vue"
export default component.exports